import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import * as $ from 'jquery';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q29',
  templateUrl: './r-q29.component.html',
  styleUrls: ['./r-q29.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ29Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  showTip = false;
  tenure_months = [];
  tenure;
  deviceWidth;
  timer;
  question_q1;
  showbutton = true;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
    for (let i = 1; i <= 37; i++) {
      if (i === 37) {
        this.tenure_months.push(36 + '+');
      } else if (i === 1) {
        this.tenure_months.push(i + ' Month');
      } else {
        this.tenure_months.push(i + ' Months');
      }
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    const dependentParam = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj.hg_res_rules[0].res_question_id });
    // console.log.log(dependentParam, this.userResponses, this.questionObj.hg_res_rules[0].res_question_id);
    this.question = this.question.replace('[enter Energy Provider name]',
    dependentParam.fieldValue.toString().replace(/\s+$/, ''));
    if (this.deviceWidth > 768) {
      const splitQuestion = this.question.split('you ');
      this.question = splitQuestion[0] + 'you';
      this.question_q1 = splitQuestion[1];
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.tenure = obj.fieldValue;
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    }

    if (_.isEmpty(this.tenure))
    {
      this.showbutton = false;
    }

    if(this.deviceWidth < 768)
    {
      setTimeout(function(){

        $('ng-select:visible').find('.ng-input').find('input').on('focus', function() { $(this).blur(); });
  
      },500)
    }
  }

  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      if (str[i].charAt(0).match(/\d+/)) {
        str[i] = str[i].charAt(0) + str[i].charAt(1).toUpperCase() + str[i].slice(2);
      } else {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
    }
    return str.join(' ');
  }

  getTenure(event) {
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({'currentId': this.data});
    }
    this.tenure = event;
    this.user_bot = true;
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }else
    {
      if(!this.showbutton)
      {
        this.next();
      }
    }
  }

  next() {
      if (_.isEmpty(this.tenure)) {
      // console.log.log('tenure:', this.tenure);
      // alert('Select the Option');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data,
      'fieldName': 'current_provider_tenure',
      'fieldValue': this.tenure
    };
    this.residentialService.updateResponses(Obj);
  }

}

